export default __webpack_public_path__ + "static/media/register.5714acf8.png";